<template>
  <o-view :has-white-background="true" :no-scroll="true">
    <o-view :bottom-padding="true">
      <o-nav-bar
        title="Cambio-inschrijving"
        :has-back-button="true"
        :has-close-button="true"
        :is-overlay="true"
      />
      <o-section-header title="Identiteitskaart">
        <template #right>
          <o-icon icon="info" @click.native="showOverlay('info')" />
        </template>
      </o-section-header>
      <o-section>
        <p>Gelieve de volgende gegevens aan te vullen.</p>
        <o-text-input label="Nummer identiteitskaart" value="123-4567890-12" />
      </o-section>
      <o-section>
        <o-text-input
          icon="date"
          type="date"
          label="Geboortedatum"
          value="1991-02-26"
        />
      </o-section>
      <o-section>
        <o-text-input label="Geboorteplaats" value="Gent" />
      </o-section>
      <o-overlay ref="info" title="Nummer identiteitskaart">
        <template #form>
          <o-id-info />
        </template>
      </o-overlay>
    </o-view>
    <o-pay-button label="Verder" to="/sales/car/cambio/onboarding/id-picture" />
  </o-view>
</template>

<script>
import OFavoriteToggle from '@/components/OFavoriteToggle.vue'
import OHeaderImage from '@/components/OHeaderImage.vue'
import OPayButton from '@/components/OPayButton.vue'
import OStarRating from '@/components/OStarRating.vue'
import OIdInfo from '@/components/overlays/OIdInfo.vue'
import OCheckbox from '@/components/base/OCheckbox.vue'
export default {
  name: 'CambioCurrent',
  components: {
    OCheckbox,
    OIdInfo,
    OFavoriteToggle,
    OHeaderImage,
    OPayButton,
    OStarRating
  }
}
</script>
